import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const ExpressiveXXXLText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text ref={ref} style={[styles.expressiveXXXLText, style]} {...props}>
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  expressiveXXXLText: {
    ...theme.typography.expressive.xxxl,
  },
});

export default ExpressiveXXXLText;
